import api from './api';
import { Company } from '../types';

export interface CompanyCreateData {
  name: string;
  reading?: string;
}

export interface CompanyUpdateData {
  name?: string;
  reading?: string;
}

export interface CompanySearchParams {
  query: string;
  limit?: number;
}

class CompanyService {
  // 会社一覧取得
  async getCompanies(search?: string, skip: number = 0, limit: number = 100): Promise<Company[]> {
    const params = new URLSearchParams();
    if (search) params.append('search', search);
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());

    const response = await api.get(`/companies?${params.toString()}`);
    return response.data;
  }

  // 会社検索（オートコンプリート用）
  async searchCompanies(query: string, limit: number = 10): Promise<Company[]> {
    const params = new URLSearchParams();
    params.append('query', query);
    params.append('limit', limit.toString());

    const response = await api.get(`/companies/search?${params.toString()}`);
    return response.data;
  }

  // 会社詳細取得
  async getCompany(id: string): Promise<Company> {
    const response = await api.get(`/companies/${id}`);
    return response.data;
  }

  // 会社作成
  async createCompany(data: CompanyCreateData): Promise<Company> {
    const response = await api.post('/companies', data);
    return response.data;
  }

  // 会社更新
  async updateCompany(id: string, data: CompanyUpdateData): Promise<Company> {
    const response = await api.put(`/companies/${id}`, data);
    return response.data;
  }

  // 会社削除
  async deleteCompany(id: string): Promise<void> {
    await api.delete(`/companies/${id}`);
  }

  // 会社名から会社を作成または取得
  async getOrCreateCompany(name: string): Promise<Company> {
    // まず検索して既存の会社を探す
    const companies = await this.searchCompanies(name, 1);

    // 完全一致する会社があれば返す
    const exactMatch = companies.find(c => c.name === name);
    if (exactMatch) {
      return exactMatch;
    }

    // なければ新規作成
    return this.createCompany({ name });
  }
}

export default new CompanyService();